<template>
  <div class="agreementsBody">
    <Header />

    <div class="agreemenstMain" v-if="authType == 1">
      <Step :num='1' />
      <h2>实名认证过程中，可能采集您的如下个人身份信息</h2>
      <div class="rule">
        <ul>
          <li>真实姓名、证件号码；</li>
          <li>个人在使用且在运营商处已实名的手机号；
            <p>（仅实名手机号认证需要提供）</p>
          </li>
          <li>个人在使用银联银行卡号及银行预留手机号；
            <p>（仅个人银行卡认证需要提供）</p>
          </li>
          <li>个人的人脸图像信息，需录制一段视频；
            <p>（仅人脸识别认证需要提供）</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="agreemenstMain" v-if="authType ==0">
      <Step :num='1' :authType="1"/>
      <h2>申请企业实名需要准备以下材料，将极大提升认证效率</h2>
      <div class="rule companyRule">
        <ul>
          <li>资质证明文件：不同类型组织需要相关部门颁发的资质证明文件的电子照片或加盖公章的复印件；
            <p>（如：企业/个体户需要提供工商营业执照）；</p>
          </li>
          <li>如果您是企业法定代表人本人，您可以直接代表企业进行认证；
            <p>（仅支持企业/个体户类型）</p>
          </li>
          <li>企业对公打款认证，需要采集企业开户银行、企业银行账号信息；
            <p>（仅支持企业对公打款认证）</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="agreementsBottom">
      <p>
        <el-checkbox v-model="checked"></el-checkbox>我已知悉上述内容并同意
          <el-button type="text" @click="goRouter('serviceAgreement')">《豸信CA实名认证服务协议》</el-button>
          <el-button type="text" @click="goRouter('certAgreement')">《数字证书服务协议》</el-button>
          <el-button type="text" @click="goRouter('privacyPolicy')">《豸信CA隐私政策》</el-button>
        <span v-if="!checked" class="checkTitle" :class="{animation:animation}">请确认并勾选协议</span>
      </p>
      <div class="lineBtn">
        <el-button type="primary" size="mini" @click="getRoute">开始认证 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
      animation: false,
      authType: '1',
      better_scroll: null
    }
  },
  created() {},
  mounted() {
    this.authType = this.$store.state.userInfo.isPersonAuth
  },
  methods: {
    goRouter(val) {
      this.$router.push({ name: val })
    },
    getRoute() {
      if (!this.checked) {
        this.animation = true
        setTimeout(() => {
          this.animation = false
        }, 1500)
      } else {
        if(this.authType == 1) {
          this.$router.push({ name: 'personEntryInfo' })
        } else {
          this.$router.push({ name: 'companyEntryInfo' })
        }
       
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agreementsBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // align-items: flex-start;
}
.agreemenstMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff url('../assets/img/agreement.png') no-repeat center 103px;
  padding: 0px 0 40px;
  h2 {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    line-height: 27px;
    padding: 198px 0 28px;
  }
  .rule {
    width: 302px;
    height: 234px;
    background: #f1f5ff;
    padding: 24px 24px 0;
    border-radius: 4px;
    margin: 0 auto;
    font-size: 12px;
    &.companyRule{
      width: 740px;
      height: 200px;
      padding: 24px 42px 0;
    }
    li {
      line-height: 18px;
      padding-bottom: 16px;
      vertical-align: middle;
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 6px;
        background: #d4d4d4;
        margin-right: 6px;
        vertical-align: middle;
      }
      p {
        padding-left: 10px;
        padding-bottom: 4px;
        line-height: 18px;
        color: #929292;
      }
    }
  }
}
.agreementsBottom {
  width: 1600px;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  .lineBtn {
    border-top: 1px solid #eceef1;
    padding: 12px 0;
    text-align: center;
  }
  .el-checkbox {
    margin-right: 5px;
  }
  .checkTitle {
    position: absolute;
    left: 392px;
    top: -36px;
    width: 122px;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #fff;
    background: #595959;
    border-radius: 4px;
    &::before {
      position: absolute;
      bottom: -6px;
      left: 58px;
      content: '';
      border-top: 6px solid #595959;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
    &.animation {
      animation: shake 0.5s;
    }
  }
}
@keyframes shake {
  0%,
  100% {
    transform: translate(0);
  }
  // 25%,
  // 75% {
  //   transform: translate(0, -8px);
  // }
  50% {
    transform: translate(0, 6px);
  }
}
</style>